import Pica from 'pica';
import { DISABLE_VISIONBOARD_PREVIEW } from '@/features'
import util from "@/util";

const DOWNSCALE_FACTOR = 8;
const USE_PICA_FOR_RESIZE = true; /* much better quality */

export default {
  methods: {
    onGeneratePreviewImage() {
      console.log("[VB] onGeneratePreviewImage");
      if ( DISABLE_VISIONBOARD_PREVIEW ) {
        return
      }
      let imgData = null;
      try {

        let canvas = document.querySelector('#stage-container canvas');
        let hiddenResizeCanvas = document.createElement('canvas')

        hiddenResizeCanvas.width = canvas.width / DOWNSCALE_FACTOR
        hiddenResizeCanvas.height = canvas.height / DOWNSCALE_FACTOR

        if ( USE_PICA_FOR_RESIZE ) {

          const pica = Pica();
          pica.resize( canvas, hiddenResizeCanvas ).then(result => {
            imgData = result.toDataURL('image/png');
            this.$store.dispatch('app/setVisionboardPreviewBase64', imgData)
          })

        } else {

          let dstCtx = hiddenResizeCanvas.getContext('2d')
          dstCtx.drawImage(canvas, 0, 0, hiddenResizeCanvas.width, hiddenResizeCanvas.height)
          imgData = hiddenResizeCanvas.toDataURL('image/jpeg', 1);

          this.$store.dispatch('app/setVisionboardPreviewBase64', imgData)
        }

      } catch (e) {
        if (e.name && e.name === 'SecurityError') {
          console.log("[VB] canvas is tainted or can not be found -> no preview");
          return null
        }
        throw e;
      }
      /* For Testing:
      if ( imgData ) {
        let img = new Image();
        img.src = imgData;
        var elem = document.createElement('div');
        elem.appendChild( img );
        elem.style.cssText = 'position: fixed; z-index: 100; background: rgb(0, 0, 0); top: 0; right: 0; border: 2px solid #f1c40f;';
        elem.addEventListener('click', this.onGeneratePreviewImage)
        document.body.appendChild(elem);
      }
      */
    },

    onExportCanvas(format, quality) {
      console.log("[VB] Exporting canvas", format, quality);
      let canvas = document.querySelector('#stage-container canvas');

      if ( !canvas ) {
        return
      }

      // TODO: Hide transformer
      // TODO: Hide Buttons / UI Elements

      let imgData = null;
      try {
        imgData = canvas.toDataURL(format, quality);
      } catch (e) {
        if (e.name && e.name === 'SecurityError') {
          this.confirm(
            "You're canvas has been tainted, which means that you imported images from an external URL.",
            "Export not possible", {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              type: 'warning',
              center: true
            })
          return
        } else {
          throw e;
        }
      }
      if ( imgData ) {
        let filename = 'visionboard1.' + format.split('/').pop();
        let blob = util.dataURLtoBlob(imgData);
        util.generateDownloadFromBlob( blob, filename, format );
      }
    },
  }
}
